import type { FarmState, Lote } from './model';

const naturalOrder = new Intl.Collator('es', { numeric: true, sensitivity: 'base' });

/** Orden de presentación: destete, ceba, otros espacios y finalmente sin asignar. */
export function sortActiveLots(state: Pick<FarmState, 'lotes' | 'espacios'>): Lote[] {
  const spaces = new Map(state.espacios.map(space => [space.id, space]));
  return state.lotes.filter(lot => lot.estado === 'activo').map(lot => {
    const spaceId = (lot.espacioActual || '').trim();
    const space = spaces.get(spaceId);
    // El tipo registrado es la referencia principal, aunque su identificador tenga otro prefijo.
    const type = space ? space.tipo : /^D(?:[-_\s]|\d|$)/i.test(spaceId) ? 'destete' : /^C(?:[-_\s]|\d|$)/i.test(spaceId) ? 'ceba' : '';
    const group = !spaceId ? 3 : type === 'destete' ? 0 : type === 'ceba' ? 1 : 2;
    return { lot, spaceId, group };
  }).sort((a, b) => a.group - b.group || naturalOrder.compare(a.spaceId, b.spaceId) || naturalOrder.compare(a.lot.id, b.lot.id))
    .map(({ lot }) => lot);
}
